import { style } from '@vanilla-extract/css';

import rootStyles from '../rootElement/Root.css';

const { rootElement } = rootStyles;

export const blockquoteElement = style({
  position: 'relative',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  display: 'flex',
  selectors: {
    [`${rootElement} > &`]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
  },
});

export const blockquote = style({
  width: '100%',
  margin: '0.5rem 0',
  padding: '0.25em 1em',
  paddingLeft: 30,
  borderLeft: '1px solid var(--accent)',
  fontSize: 'large',
  letterSpacing: -0.4,
  lineHeight: 2,
});
